/* global angular, moment */
/**
 * Created by lari on 26/05/2017.
 */
(function () {
  'use strict';
  angular.module('vcclient')
    .component('svedit', {
      bindings: {
        svdata: '=',
        parentsave: '&'
      },
      templateUrl: 'vcclient/svedit-component.tpl.html',
      controllerAs: 'vm',
      controller: ['$log', '$scope',
        function ($log, $scope) {
          let vm = this;
          vm.title = 'svedit-component-controller';
          vm.svsave = svsave;
          vm.save = save;


          vm.formatbdate = formatbdate;
          vm.clearbdate = clearbdate;

          vm.formatSVNR = formatSVNR;
          vm.clearSVNR = clearSVNR;
          vm.clearSV = clearSV;

          vm.savePractDoctor = savePractDoctor;
          vm.saveRefDoctor = saveRefDoctor;
          vm.clearPractDoctor = clearPractDoctor;
          vm.clearRefDoctor = clearRefDoctor;

          vm.calcBMI = calcBMI;
          vm.setBMI = setBMI;

          vm.validateSVNR = validateSVNR;

          vm.childsave = childsave;


          vm.$scope = $scope;
          // Note: first function call is a weird trick to eliminate hardcoded local vm. this identifier!
          $scope.$watch(function () {
            return vm.svdata;
          }, function (scope) {
            $log.debug('scope in watch: ', scope);
            // noinspection JSUnresolvedVariable
            if (angular.isDefined(scope) && angular.isDefined(scope.svnr) && angular.isString(scope.svnr)) {
              // noinspection JSUnresolvedVariable
              vm.isvalidsvnr = vm.validateSVNR(scope.svnr);
            }
          });

          $scope.$watch(function () {
            return vm.svdata;
          }, function (scope) {
            $log.debug('scope in watch: ', scope);
            // noinspection JSUnresolvedVariable
            if (angular.isDefined(scope) && angular.isDefined(scope.insuredwith) && angular.isDefined(scope.insuredwith.svnr) && angular.isString(scope.insuredwith.svnr)) {
              // noinspection JSUnresolvedVariable
              vm.inswvalid = vm.validateSVNR(scope.insuredwith.svnr);
            }
          });

          // Init Routine
          vm.$onInit = function () {

            // make a copy of the current object state
            vm.lastsvdata = angular.copy(vm.svdata);
            $log.debug(' ### svedit $onInit vm.svdata: ', vm.svdata);
            if (angular.isDefined(vm.svdata) && angular.isDefined(vm.svdata.birthdate) && angular.isUndefined(vm.svdata.bdateat)) {
              formatbdate(vm.svdata.birthdate);
            }


            if (angular.isDefined(vm.svdata) && angular.isDefined(vm.svdata.svnr)) {
              vm.isvalidsvnr = vm.validateSVNR(vm.svdata.svnr);
              $log.debug('isvalid: ', vm.isvalidsvnr);
            }
            // noinspection JSUnresolvedVariable
            if (angular.isDefined(vm.svdata) && angular.isDefined(vm.svdata.insuredwith) && angular.isDefined(vm.svdata.insuredwith.svnr)) {
              // noinspection JSUnresolvedVariable
              vm.inswvalid = vm.validateSVNR(vm.svdata.insuredwith.svnr);
              $log.debug('inswvalid: ', vm.inswvalid);
            }
            if (angular.isDefined(vm.svdata) && (angular.isUndefined(vm.svdata.bmi) || !angular.isNumber(vm.svdata.bmi))) {
              setBMI();
            }
            // create working copy
            vm.svdata = angular.copy(vm.svdata);
            vm.save();
          };


          function childsave(key, value) {
            vm.svdata[key] = value;
            vm.save();
          }

          function saveRefDoctor(doctor) {
            vm.svdata.refdoctor = doctor;
            vm.save();
          }

          function savePractDoctor(doctor) {
            vm.svdata.practdoctor = doctor;
            vm.save();
          }


          function svsave(sv, svref) {
            vm.svdata.sv = angular.copy(sv);
            vm.svdata.svref = svref;
            vm.save();
          }

          function save() {
            vm.parentsave();
          }

          function formatbdate(date) {
            // moment.locale('de-at');
            let returnval;
            // noinspection ES6ModulesDependencies
            let bdate = moment(date, ['D.M.YYYY', 'DD.MM.YYYY', 'D/M/YYYY', 'DDMMYYYY']);
            // noinspection ES6ModulesDependencies
            let plausible = (bdate.isAfter(moment('1900-01-01', 'YYYY-MM-DD')) && bdate.isBefore(moment().add(1, 'days')));
            let valid = bdate.isValid();
            // $log.debug('debug: valid, plausible: ', valid, plausible);

            if (!plausible) {
              vm.bdateerror = 'Unplausibles Datum';
              returnval = 'implausible';
            }

            if (!valid) {
              vm.bdateerror = 'Ungültiges Datum';
              returnval = 'invalid';
            }

            if (valid && plausible) {
              vm.svdata.bdateat = bdate.format('DD.MM.YYYY');
              vm.svdata.bdateiso = bdate.toISOString();
              vm.svdata.bdatesortable = bdate.format('YYYY-MM-DD');
              vm.svdata.bdateat = bdate.format('DD.MM.YYYY');
              vm.svdata.bdatejs = bdate.format();
              vm.svdata.bdatesv = bdate.format('DDMMYY');
              delete vm.bdateerror;
              returnval = bdate.format('DD.MM.YYYY');
              vm.save();
            }
            return returnval;
          }

          function clearbdate() {
            delete vm.svdata.birthdate;
            delete vm.svdata.bdateiso;
            delete vm.svdata.bdatesortable;
            delete vm.svdata.bdatejs;
            delete vm.svdata.bdateat;
            delete vm.svdata.bdatesv;
            delete vm.bdateerror;
            vm.save();
          }

          function validateSVNR(svnr) {
            let result = false;
            if (angular.isDefined(svnr) && svnr.length > 0) {
              let nr = svnr.split('');
              let checksum = (5 * parseInt(nr[4], 10) +
                8 * parseInt(nr[5], 10) +
                4 * parseInt(nr[6], 10) +
                2 * parseInt(nr[7], 10) +
                parseInt(nr[8], 10) +
                6 * parseInt(nr[9], 10) +
                3 * parseInt(nr[0], 10) +
                7 * parseInt(nr[1], 10) +
                9 * parseInt(nr[2], 10)) % 11;
              result = checksum === parseInt(nr[3], 10);
            }
            return result;
          }

          function formatSVNR() {
            $log.debug('debug: formatSVNR called');
            let valid = false;
            // noinspection JSUnresolvedVariable
            if (angular.isDefined(vm.svdata.svnrlfd) && angular.isDefined(vm.svdata.bdatesv)) {
              // noinspection JSUnresolvedVariable
              let svnr = vm.svdata.svnrlfd + vm.svdata.bdatesv;
              valid = vm.validateSVNR(svnr);
              vm.isvalidsvnr = valid;
              vm.svdata.svnr = svnr;
              // noinspection ES6ModulesDependencies
              vm.svdata.medicalnetnr = svnr.substr(0, 8) + moment(vm.svdata.bdateiso).year().toString().substr(0, 2) + svnr.substr(8, 2);
            }
            vm.isvalidsvnr = valid;
            if (vm.isvalidsvnr) {
              vm.save();
            }
            return valid;
          }

          function clearSVNR() {
            delete vm.svdata.svnr;
            vm.save();
          }

          function calcBMI(height, weight) {
            let bmi = 0;
            if (angular.isNumber(height) && angular.isNumber(weight) && height !== 0) {
              bmi = Math.round(weight * 10000 / (height * height) * 10) / 10;
            }
            return bmi;
          }

          function setBMI() {
            if (angular.isDefined(vm.svdata.height) && angular.isDefined(vm.svdata.weight)) {
              vm.svdata.bmi = calcBMI(vm.svdata.height, vm.svdata.weight);
            }
            vm.save();
          }


          function clearSV() {
            delete vm.svdata.sv;
            delete vm.svdata.svref;
            vm.save();
          }

          function clearRefDoctor() {
            delete vm.svdata.refdoctor;
            vm.save();
          }

          function clearPractDoctor() {
            delete vm.svdata.practdoctor;
            vm.save();
          }

          vm.bdatehelp = 'Eingabe im Format T.M.JJJJ, T-M-JJJJ oder TTMMJJJJ. Der Inhalt wird automatisch im zu TT.MM.JJJJ formatiert';

        }] // controller
    }); // component

// klammerfriedhof
}());